

































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import { WraLoader } from '@/common/loader';
import globals from '@/globals';
import StandardLayoutMenu from '@/layouts/standard/components/StandardLayoutMenu.vue';
import StandardLayoutNav from '@/layouts/standard/components/StandardLayoutNav.vue';
import StandardLayoutTitle from '@/layouts/standard/components/StandardLayoutTitle.vue';
import { loginRoute } from '@/pages/login/route';
import { RootStore } from '@/store';
import { UserStore } from '@/store/user';


@Component({
  components: {
    StandardLayoutMenu,
    StandardLayoutTitle,
    StandardLayoutNav,
    WraLoader,
  },
})
export default class StandardLayout extends Vue {
  @Action loadDefault!: RootStore.Action<'loadDefault'>;
  isLoaded = false;


  async mounted() {
    await this.loadDefault();
    this.isLoaded = true;

    this.startPolling();
  }

  async beforeDestroy() {
    this.stopPolling();
  }

  ////

  private cancelPolling: NodeJS.Timeout;
  @UserStore.Bind.Action validate!: UserStore.Action<'validate'>;

  private startPolling() {
    this.cancelPolling = setInterval(async () => {
      try {
        await this.validate();
      }
      catch (ex) {
        console.log('Token expired on invalid.');
        await this.$router.push({ name: loginRoute.name });
      }
    }, globals.sessionCheckInterval);
  }

  private stopPolling() {
    if (this.cancelPolling) {
      clearInterval(this.cancelPolling);
    }
  }
}
